<div class="row">
  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Bulletin Search</h4>
        <a class="btn btn-success" routerLink="/Auth/Bulletin/New" role="button">Create</a>

        <app-ngbAccordion class="m-t-10" headerName="Search Criteria">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Keyword</label>
                <input type="text" class="form-control" [(ngModel)]="searchFilter.filter.Keyword" placeholder="">
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Target Date</label>
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="yyyy/mm/dd" ngbDatepicker
                    #EffectDate="ngbDatepicker" [(ngModel)]="searchFilter.filter.EffectiveDate">
                  <div class="input-group-append">
                    <button class="btn" (click)="EffectDate.toggle()" type="button"><i
                        class="fa fa-calendar"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>IsEnabled</label>
                <ng-select [searchable]="false" [items]="DropdownEnabled" bindValue="value" bindLabel="text"
                  [clearable]="false" [(ngModel)]="searchFilter.filter.IsEnabled">
                </ng-select>
              </div>
            </div>
          </div>
          <button id="btnSearch" type="button" class="btn btn-secondary"
            (click)="this.searchFilter.filter.PageIndex = 1;Search()">Search</button>
        </app-ngbAccordion>
        
        <app-ngbAccordion class="m-t-10" headerName="Search Result">
          <div class="rowCard">
            <app-table-pager [Income]=TableData (PageInfo)="onChangePageInfo($event)"></app-table-pager>
          </div>
          <app-table [Income]=TableData [TableSetting]=TableSetting (DeleteEvent)="Delete($event)"
            (TableInfo)="onChangeTableInfo($event)">
          </app-table>
          <div class="dataTb">
            <app-table-pager [Income]=TableData (PageInfo)="onChangePageInfo($event)"></app-table-pager>
          </div>
        </app-ngbAccordion>
      </div>
    </div>
  </div>
</div>


